import { Icon } from '@iconify/react'
import { Dropdown } from 'antd'

import { parseReleaseDates, getStoryMapFilterClass } from '../utils'
import styles from '../../ProjectStoryMapBoard.module.css'

const ReleaseHeaderBar = ({
    release,
    releaseDrag,
    onOpenRelease,
    releaseMenu,
    isFilterActive = false,
    readOnly = false,
    collapsed = false,
    onToggleCollapse,
}) => {
    const { start, due } = parseReleaseDates(release.dateRange)
    const filterClass = getStoryMapFilterClass(
        isFilterActive,
        release.matchesFilter,
        styles
    )

    const handleTitleClick = (event) => {
        event.stopPropagation()
        onOpenRelease?.(release.id)
    }

    const handleCollapseClick = (event) => {
        event.stopPropagation()
        onToggleCollapse?.()
    }

    return (
        <div className={`${styles.releaseHeaderBar} ${filterClass}`}>
            <div className={styles.releaseHeaderLeft}>
                {!readOnly ? (
                    <button
                        type="button"
                        className={styles.dragHandle}
                        {...(releaseDrag?.dragHandleProps || {})}
                        aria-label="Drag release"
                    >
                        <Icon icon="mdi:drag-vertical" width={16} />
                    </button>
                ) : null}
                <span className={styles.releaseFlag}>
                    <Icon icon="mdi:flag-outline" width={13} />
                </span>
                <button
                    type="button"
                    className={styles.releaseTitle}
                    onClick={handleTitleClick}
                    title={release.title}
                >
                    {release.title}
                </button>
                {release.stories.length > 0 ? (
                    <span className={styles.releaseStoryBadge}>
                        {release.stories.length}{' '}
                        {release.stories.length === 1 ? 'story' : 'stories'}
                    </span>
                ) : null}
                <button
                    type="button"
                    className={styles.releaseCollapseBtn}
                    aria-label={collapsed ? 'Expand release' : 'Collapse release'}
                    aria-expanded={!collapsed}
                    onClick={handleCollapseClick}
                >
                    <Icon
                        icon={collapsed ? 'mdi:chevron-right' : 'mdi:chevron-down'}
                        width={16}
                    />
                </button>
            </div>
            {(start || due) && (
                <div className={styles.releaseHeaderRight}>
                    {start && (
                        <span className={styles.releaseDateItem}>
                            <Icon icon="mdi:calendar-outline" width={13} />
                            Start {start}
                        </span>
                    )}
                    {due && (
                        <span className={styles.releaseDateItem}>
                            <Icon icon="mdi:calendar-outline" width={13} />
                            Due {due}
                        </span>
                    )}
                </div>
            )}
            {(releaseMenu?.(release.id) ?? []).length > 0 ? (
                <Dropdown menu={{ items: releaseMenu(release.id) }} trigger={['click']}>
                    <button
                        type="button"
                        className={styles.releaseMenuBtn}
                        aria-label="Release options"
                        onClick={(event) => event.stopPropagation()}
                    >
                        <Icon icon="mdi:dots-vertical" width={16} />
                    </button>
                </Dropdown>
            ) : null}
        </div>
    )
}

export default ReleaseHeaderBar
